import palette from "./brandPalette.json";

const brandColors = palette.colors;

export const gradients = {
  // Brand palette: deep operational navy, muted teal, and warm signal accents.
  primary: `linear-gradient(135deg, ${brandColors.darkBlue} 0%, ${brandColors.mediumBlue} 54%, ${brandColors.brightBlue} 100%)`,
  primaryReversed: `linear-gradient(135deg, ${brandColors.brightBlue} 0%, ${brandColors.mediumBlue} 48%, ${brandColors.darkBlue} 100%)`,

  heading: `linear-gradient(135deg, ${brandColors.darkBlue} 0%, ${brandColors.mediumBlue} 58%, ${brandColors.brightBlue} 100%)`,
  hero: `linear-gradient(180deg, ${brandColors.white} 0%, ${brandColors.cloud} 58%, ${brandColors.mist} 100%)`,

  // Smaller decorative surfaces and icon fills.
  iconGradient: `linear-gradient(135deg, ${brandColors.mediumBlue} 0%, ${brandColors.brightBlue} 100%)`,
  iconGradientReversed: `linear-gradient(135deg, ${brandColors.lightBlue} 0%, ${brandColors.mediumBlue} 100%)`,

  secondary: "linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(255, 255, 255, 0.78) 100%)",
  tertiary: `linear-gradient(180deg, ${brandColors.cloud} 0%, #EEF2F6 100%)`,
  colors: brandColors,
  scale: {
    radius: {
      sm: 6,
      md: 8,
      lg: 10,
      xl: 12,
    },
    shadow: {
      soft: "0 16px 36px -22px rgba(11, 18, 32, 0.38)",
      raised: "0 24px 56px -28px rgba(11, 18, 32, 0.42)",
    },
  },
};
